export default __webpack_public_path__ + "static/Fullscreen Background-07517d46ce106cc409530571c05055a7.png";